import {
    requestMethodTypes,
    requestHeaderNames,
    requestHeaderValue,
} from '../Constants/api.constants';

const playbackPrecisionRequest = (
    requestData = {}
) => {
    const {
        AUTHORIZATION,
        CONTENT_TYPE,
    } = requestHeaderNames;
    const {
        CONTENT_TYPE_JSON,
        BEARER,
    } = requestHeaderValue;

    const method = requestMethodTypes.GET;
    const headers = {
        [CONTENT_TYPE]: CONTENT_TYPE_JSON,
        [AUTHORIZATION]: `${BEARER} ${requestData.token}`,
    };

    const body = {
        AnalyticsSessionId: requestData.analyticsSessionId,
        AssetTypeId: requestData.assetTypeId,
        VideoFormat: requestData.videoFormat,
        VideoType: requestData.videoType,
        Manufacturer: requestData.manufacturer,
        Platform: requestData.platform || '',
    };

    const request = {
        method,
        headers,
        body,
    };

    return request;
};

export default playbackPrecisionRequest;
